module.exports = __webpack_public_path__ + "img/Armorer1.d0a29d05.png";